<ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-back-button slot="start"></ion-back-button>
        <ion-title>Members</ion-title>
        <ion-button  [permissionModule]="ApiModules.OrganisationUser"
                     [permissionOperation]="ApiOperations.create" (click)="addUser()" fill="clear" slot="end">
            <ion-icon name="add-outline"></ion-icon>
          Add
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content>


    <ion-list *ngIf="organisationUsers$ | async as organisationUsers" sxMaxWidth="500px" sxMargin="0 auto">

      <ion-item button="" *ngFor="let organisationUser of organisationUsers" (click)="openViewUser(organisationUser)">
            <avatar-round
                    [imageUrl]="organisationUser?.user?.displayPictureUrl"
                    [title]="organisationUser?.user?.name"
                    [size]="40"
                    slot="start"></avatar-round>

        <ion-label sxWidth="100px">{{ organisationUser?.user?.name }} <br/>
                <span style="font-size: 12px">{{ organisationUser?.user?.email }}</span>
        </ion-label>
        <ion-label sxWidth="50px" class="role-label" color="medium" slot="end">{{
                organisationUser.role | roleTitle
                }}</ion-label>

        </ion-item>
    </ion-list>
</ion-content>
